module.exports = __webpack_public_path__ + "img/@service_img_00.a523689c.jpg";